import { useContext, useMemo, useState } from 'react';
import MenuItem from './MenuItem';
import { UserContext } from '@context/createContext.jsx';
import { useNavigate } from 'react-router-dom';
import ToastError from '../modules/toast/ToastError.jsx';
import ToastSuccess from '../modules/toast/ToastSuccess.jsx';
import { sidebarDesktop } from '@/constants/sidebarData';
import DefaultImageReal from '../modules/Default-Image/DefaultImageReal';

// لیست دامنه‌های مجاز برای دسترسی به فایلینگ پرو
const ALLOWED_SUBDOMAINS = [
  'amlakeskan.dubz.ir',
  'ideal.dubz.ir',
  'mina.dubz.ir',
  'kimia-gostar.dubz.ir',
  'madar.dubz.ir',
  'sahel.dubz.ir',
  'benolmelal.dubz.ir',
  'khaneshoma.dubz.ir',
  'diyar.dubz.ir',
  'maskangostar.dubz.ir',
  'dubzhome.dubz.ir',
];

export default function Sidebar() {
  const {
    realEstate,
    // clearUser,
    user: { Name, id, UserType, RealEstateId, PhoneNumber },
  } = useContext(UserContext);
  // const [openModal, setOpenModal] = useState(false);

  const navigate = useNavigate();
  const [isProLoading, setIsProLoading] = useState(false);
  const isEskanSubdomain = useMemo(
    () => ALLOWED_SUBDOMAINS.includes((realEstate?.subdomain || '').toLowerCase()),
    [realEstate?.subdomain],
  );

  const navigateSubdomain = () => {
    // استفاده از domain اگر وجود داشته باشد، در غیر این صورت از subdomain استفاده می‌کنیم
    const baseUrl = realEstate?.domain && realEstate.domain.trim() ? realEstate.domain : realEstate?.subdomain;

    if (UserType == 'Agent') {
      if (!baseUrl || !realEstate.color) {
        ToastError({ content: 'اطلاعات املاک شما کامل نیست' });
      } else {
        window.open(`https://${baseUrl}/${Name.username}`, '_blank', 'noopener,noreferrer');
      }
    } else {
      if (!baseUrl) {
        ToastError({ content: 'برای سایت املاک هنوز آدرسی ثبت نشده' });
        navigate('settings#SiteSubdomain');
      } else if (!realEstate.color) {
        ToastError({ content: 'برای سایت املاک هنوز رنگ سازمانی ثبت نشده' });
        navigate('settings#OrganizationalColor');
      } else {
        window.open(`https://${baseUrl}`, '_blank');
      }
    }
  };

  const loginToPro = async () => {
    try {
      if (isProLoading) return;
      setIsProLoading(true);

      if (UserType !== 'RealEstate') {
        ToastError({ content: 'ورود به پرو فقط برای مدیر املاک فعال است' });
        return;
      }

      const name = realEstate?.name || Name?.fullName || '';
      const area = realEstate?.area_of_activity || '';
      const address = realEstate?.address || '';
      const post_code = '0987654321';
      const phonenumber = realEstate?.phone_number || '';
      const img_url = realEstate?.profile || realEstate?.banner || '';
      const owner_first_name = Name?.firstName || '';
      const owner_last_name = Name?.lastName || '';
      const owner_phone = PhoneNumber || '';

      if (!name || !area || !address || !phonenumber || !owner_first_name || !owner_last_name || !owner_phone) {
        ToastError({ content: 'برخی اطلاعات مدیر/املاک ناقص است. لطفا اطلاعات املاک و پروفایل را تکمیل کنید.' });
        return;
      }

      const form = new URLSearchParams();
      form.append('method', 'RealestateRegister');
      form.append('name', name);
      form.append('area', area);
      form.append('address', address);
      form.append('post_code', post_code);
      form.append('phonenumber', phonenumber);
      form.append('img_url', img_url);
      form.append('owner_first_name', owner_first_name);
      form.append('owner_last_name', owner_last_name);
      form.append('owner_phone', owner_phone);

      const res = await fetch('https://pro-api.dubz.ir/app.SSO.php', {
        method: 'POST',
        body: form,
      });

      const data = await res.json();
      if (!res.ok || !data?.ok) {
        throw new Error(data?.message || 'خطا در ثبت/بروزرسانی املاک در پرو');
      }

      ToastSuccess({ content: 'اتصال به پرو با موفقیت انجام شد. در حال انتقال...' });
      const userId = data?.manager_user_id;
      if (userId) {
        window.open(`https://pro.dubz.ir?u=${encodeURIComponent(userId)}`, '_blank', 'noopener,noreferrer');
      }
    } catch (error) {
      ToastError({ content: error?.message || 'خطایی رخ داد. دوباره تلاش کنید.' });
    } finally {
      setIsProLoading(false);
    }
  };

  return (
    <div className="p-4 h-screen max-lg:hidden">
      <div className="w-64 h-full rounded-2xl bg-blackFont-50 dark:bg-blackFont-800 px-4 flex flex-col justify-between max-lg:hidden border-[1px] border-blackFont-200 dark:border-blackFont-700">
        <div className="flex flex-col pt-7">
          <a href="/" className="flex flex-row items-center gap-3 text-sm md:text-base mb-12">
            <div className="h-10 w-10 overflow-hidden">
              {/* <DefaultImageReal /> */}
              <img src="svg/DubzLogo.svg" alt="" className="object-cover" />
            </div>
            <p className="text-blackFont-800 dark:text-white whitespace-nowrap line-clamp-1 font-[800] mt-2 text-lg">
              پنل مدیریت
            </p>
          </a>
          <div className="flex flex-col gap-3">
            {UserType == 'Agent' &&
              sidebarDesktop
                .filter((item) => item.agent === true)
                .map((i) => <MenuItem RealEstateId={RealEstateId} key={i.id} {...i} />)}

            {UserType == 'RealEstate' &&
              sidebarDesktop
                .filter((item) => item.rsOwner === true)
                .map((i) => <MenuItem RealEstateId={RealEstateId} key={i.id} {...i} />)}
          </div>
        </div>
        <div className="w-full flex flex-col items-start mb-5 gap-2">
          {/* <button
            onClick={loginToPro}
            className="w-full mx-auto text-sm text-text-normal transition-all hover:bg-gray border-[1px] border-light-grey rounded-lg py-2 flex flex-row items-center justify-center px-3 gap-3 cursor-pointer"
          >
            {isProLoading ? (
              <svg
                className="animate-spin"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M12 2v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                <path d="M12 18v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                <path d="M4.93 4.93l2.83 2.83" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                <path d="M16.24 16.24l2.83 2.83" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                <path d="M2 12h4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                <path d="M18 12h4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                <path d="M4.93 19.07l2.83-2.83" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                <path d="M16.24 7.76l2.83-2.83" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
              </svg>
            ) : (
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M15 3h4a2 2 0 0 1 2 2v4"
                  stroke="#616161"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M21 9l-7.5 7.5a2.121 2.121 0 0 1-3 0L7 13"
                  stroke="#616161"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M3 7V5a2 2 0 0 1 2-2h2"
                  stroke="#616161"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M7 21H5a2 2 0 0 1-2-2v-2"
                  stroke="#616161"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M21 17v2a2 2 0 0 1-2 2h-2"
                  stroke="#616161"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            )}
            <p>ورود به پرو</p>
          </button> */}
          {isEskanSubdomain && (
            <button
              type="button"
              onClick={() => window.open('https://pro.dubz.ir', '_blank', 'noopener,noreferrer')}
              className="w-full mx-auto text-sm font-semibold text-white transition-all hover:scale-[1.01] bg-gradient-to-r from-[#00C29A] via-[#00A1E0] to-[#0060E6] shadow-[0_18px_35px_rgba(0,96,230,0.25)] rounded-2xl py-3 px-4 flex flex-row items-center justify-between gap-3 cursor-pointer"
            >
              <span className="flex items-center justify-center rounded-xl bg-white/15 p-2 text-white">
                <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M4 9.5C4 7.567 5.567 6 7.5 6H12L14 8H20.5C21.8807 8 23 9.11929 23 10.5V19.5C23 21.433 21.433 23 19.5 23H7.5C5.567 23 4 21.433 4 19.5V9.5Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M16 12.5H21M21 12.5L18.75 10.25M21 12.5L18.75 14.75"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
              <div className="flex flex-col items-end flex-1">
                <p>ورود به فایلینگ پرو</p>
                <span className="text-xs font-normal text-white/80">دسترسی ویژه املاک های وی آی پی</span>
              </div>
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                className="text-white/90"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9 6L15 12L9 18"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          )}
          <button
            disabled={!RealEstateId}
            onClick={navigateSubdomain}
            className="w-full mx-auto text-sm text-text-normal dark:text-white disabled:bg-light-grey dark:disabled:bg-blackFont-700 disabled:cursor-not-allowed transition-all hover:bg-gray dark:hover:bg-blackFont-700 border-[1px] border-light-grey dark:border-blackFont-700 rounded-lg py-2 flex flex-row items-center justify-center px-3 gap-3 cursor-pointer"
          >
            <svg
              width="25"
              height="24"
              viewBox="0 0 25 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="text-text-normal dark:text-white"
            >
              <path
                d="M10.5 16.9498H6.71C3.34 16.9498 2.5 16.1098 2.5 12.7398V6.73979C2.5 3.36979 3.34 2.52979 6.71 2.52979H17.24C20.61 2.52979 21.45 3.36979 21.45 6.73979"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M10.5 21.4702V16.9502"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M2.5 12.9502H10.5"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M7.24023 21.4702H10.5002"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M22.5003 12.7998V18.5098C22.5003 20.8798 21.9103 21.4698 19.5403 21.4698H15.9903C13.6203 21.4698 13.0303 20.8798 13.0303 18.5098V12.7998C13.0303 10.4298 13.6203 9.83984 15.9903 9.83984H19.5403C21.9103 9.83984 22.5003 10.4298 22.5003 12.7998Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M17.7441 18.25H17.7531"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <p className="text-text-normal dark:text-white">نمایش سایت من</p>
          </button>

          {/* <div
          onClick={(e) => {
            setOpenModal(true);
          }}
          className="w-full mx-auto text-sm text-error transition-all hover:border-error hover:bg-error hover:text-white py-2 border-[1px] border-white rounded-lg flex flex-row items-center justify-center px-3 gap-3 cursor-pointer"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M15.0996 7.55999C14.7896 3.95999 12.9396 2.48999 8.88961 2.48999H8.75961C4.28961 2.48999 2.49961 4.27999 2.49961 8.74999V15.27C2.49961 19.74 4.28961 21.53 8.75961 21.53H8.88961C12.9096 21.53 14.7596 20.08 15.0896 16.54"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M8.99988 12H20.3799"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M18.15 8.6499L21.5 11.9999L18.15 15.3499"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <p>خروج از داشبورد</p>
        </div> */}
        </div>
        {/* {openModal && (
        <ConfirmationModal
          setShowModal={setOpenModal}
          handler={() => logoutHandler()}
          title="خروج از حساب کاربری"
          desc="آیا از خروج از حساب کاربری خود اطمینان دارید؟"
          btnText="تأیید خروج"
        />
      )} */}
      </div>
    </div>
  );
}
